import {
  applySpec,
  castArray,
  constant,
  flow,
  get,
  pipe,
  stubString,
  toDefaultEmptyString,
} from '@logistics-frontend/utils'

import {Parcel, ParcelPaymentType, SddClaimProducts} from '../types'
import {toProducts} from './to-products'

// --- Default Values Helpers ---
const DEFAULT_PAYMENT_TYPE = ParcelPaymentType.Payed
const DEFAULT_BARCODE_VALUE = ''
const DEFAULT_PARCEL_SIZE = 'small'

// --- Initial Parcel Builders ---
export const toInitialParcel: (parcel?: Parcel) => Parcel = applySpec<Parcel>({
  barcode: constant(DEFAULT_BARCODE_VALUE),
  name: stubString,
  payment: constant(DEFAULT_PAYMENT_TYPE),
  products: toProducts, // TODO поменять на нормальный билдер
  size: constant(DEFAULT_PARCEL_SIZE),
})

export const toInitialParcels: () => Parcel[] = flow(toInitialParcel, castArray)

// --- Filled Parcel Builders ---
export const toFilledParcel = (items?: SddClaimProducts, isPaymentOnDemand?: boolean): Parcel => ({
  barcode: DEFAULT_BARCODE_VALUE,
  name: pipe(items, get('[0].title'), toDefaultEmptyString),
  payment: isPaymentOnDemand ? ParcelPaymentType.OnDemand : DEFAULT_PAYMENT_TYPE,
  products: toProducts(items),
  size: DEFAULT_PARCEL_SIZE,
})

export const toFilledParcels = (items?: SddClaimProducts, isPaymentOnDemand?: boolean): Parcel[] => [
  toFilledParcel(items, isPaymentOnDemand),
]
